import React from 'react'

function NotFound() {
  return (
    <div style={{width:"100%",height: "100%"}}>
        <img width={"100%"} height="90%"  src="https://kfg6bckb.media.zestyio.com/yalantis-interactive-404.gif" alt="" />
    </div>
  )
}

export default NotFound